<template>
    <section>
        <div class="filter search_only">
            <div class="field_left">
                <p class="field">
                    <label for="vyhledavani" v-translate>Vyhledávání</label>
                    <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText" type="text">
                    <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')" :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
                </p>
            </div>
        </div>

        <div class="table_overflow">
          <table class="vypis">
            <thead>
                <tr>
                    <th class="no_padding drag_drop" />
                    <th class="no_padding checkbox"></th>
                    <th><span class="name"><strong v-translate>Název</strong></span></th>
                    <th><span class="name"><strong v-translate>Typ zprávy</strong></span></th>
                    <th><span v-translate>Přečteno</span></th>
                    <th><span v-translate>Smazáno</span></th>
                    <th><span v-translate>Vynucené potvrzení</span></th>
                    <th><span v-translate>Datum odeslání</span></th>
                    <th class="no_padding edit" />
                </tr>
            </thead>
            <tbody>
                <MessageRow
                    v-for="message in filteredMessages"
                    :message="message"
                    :key="message.id"
                    :isDeletable="isEditable"
                    :messageTypes="messageTypes"
                    :selectedEntities="selectedEntities"
                    @input="select"
                    @deleteMessage="onDeleteMessage" />
            </tbody>
        </table>
        </div>
      <local-list-action-line
          :entities="filteredMessages"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="executeMultipleAction"
      ></local-list-action-line>
    </section>
</template>

<script>
import MessageRow from "./MessageRow";
import localTable from "@/components/mixins/local-table"

export default {
    name: "Messages",
    components: {MessageRow},
    mixins: [localTable],
    props: {
      subscriber: Object,
      messages: Array,
      isEditable: Boolean,
    },
    data () {
        return {
            searchText: ""
        }
    },
    methods: {
        clearFilter() {
            this.searchText = "";
        },
        onDeleteMessage(id) {
            this.$emit('deleteMessage', id);
        },
      executeMultipleAction(action, activeKey) {
        let actionIds = this.selectedEntities.join();
        switch (action) {
          case 'delete-multi':
            this.onDeleteMessage(actionIds);
            break;
          default:
            this.runMultipleAction(action, activeKey);
        }
      }
    },
    computed: {
        entities(){
          return Object.values(this.filteredMessages);
        },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
          {value: 'delete-multi', text: this.$gettext('Smazat')}
        ];
      },
        csvHeaders(){
          return {
            'name': {name: this.$gettext('Název')},
            'messageType': {name: this.$gettext('Typ zprávy'), callback: (entity) => { return this.messageTypes[entity.message_type]}},
            'is_readed': {name: this.$gettext('Přečteno'),  callback: (entity) => {return entity.is_readed ? (this.$_datetime_format(entity.is_readed) + ', '+ entity.name_device_read) : this.$gettext("Ne")}},
            'is_deleted': {name: this.$gettext('Smazáno'),  callback: (entity) => {return entity.deleted ? (this.$_datetime_format(entity.deleted) + ', '+ entity.name_device_delete) : this.$gettext("Ne")}},
            'forced_confirmation': {name: this.$gettext('Vynucené potvrzení'),  callback: (entity) => {return entity.forced_confirmation ? this.$_datetime_format(entity.forced_confirmation) : this.$gettext("Ne")}},
            'timestamp_created': {name: this.$gettext('Datum odeslání')},
          }
        },
        filteredMessages() {
            if (!this.searchText) {
                return this.messages;
            }

            let searchText = this.searchText.toLowerCase();

            return this.messages.filter((message) => {
                return message.name.toLowerCase().includes(searchText)
                    || message.id.toString().includes(searchText);
            });
        },
        messageTypes() {
            return {
                'info': this.$gettext('Informativní sdělení'),
                'maintenance_info': this.$gettext('Servisní informace'),
                'new_service': this.$gettext('Nová služba'),
                'fault': this.$gettext('Porucha'),
                'maintenance': this.$gettext('Servis'),
                'billing': this.$gettext('Platby')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/messages/Messages.vue